import { render } from "./BehfamLOGOWhite.vue?vue&type=template&id=0aa91eb6&scoped=true"
import script from "./BehfamLOGOWhite.vue?vue&type=script&lang=js"
export * from "./BehfamLOGOWhite.vue?vue&type=script&lang=js"

import "./BehfamLOGOWhite.vue?vue&type=style&index=0&id=0aa91eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa91eb6"]])

export default __exports__